import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { OrgTableUpdateItem } from 'types'

export const batchUpdateItems = async (updates: OrgTableUpdateItem[]) => {
  const response = await axios.put(`${baseUrl}/aws/organizations_table/batchupdate/contracts`, { updates })
  return response.data
}

export const useBatchRequestApproval = () => {
  const _queryClient = useQueryClient()

  return useMutation({
    mutationFn: (updates: OrgTableUpdateItem[]) => batchUpdateItems(updates),
    onSuccess: () => {
      console.log('[useBatchUpdateItems] ✅ Batch update success')
      // ✅ Optional: Invalidate your orgs table
      //   queryClient.invalidateQueries({queryKey: ['organizations_table', 'allItems']})
    },
    onError: error => {
      console.error('[useBatchUpdateItems] ❌ Batch update failed', error)
    },
  })
}
